import script from "./changes-since-last-visit-line.vue?vue&type=script&setup=true&lang=ts"
export * from "./changes-since-last-visit-line.vue?vue&type=script&setup=true&lang=ts"

import "./changes-since-last-visit-line.vue?vue&type=style&index=0&id=e378d7da&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e378d7da"]])

export default __exports__